import ResendInactiveAccountError from './ResendInactiveAccountError';
class InvestorIsNotLocked extends ResendInactiveAccountError {
    constructor(emailAddress, options) {
        super(`The email address '${emailAddress}' is not locked`, options);
    }
}
export default InvestorIsNotLocked;
